module.exports = __webpack_public_path__ + "img/EU.5ba425d2.svg";